"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var tslib_1 = require("tslib");
var Item_1 = tslib_1.__importDefault(require("./Item"));
require("./../../utils/style").injectStyle("components/Form/style/index.css", "[data-duim-0-49-1~=\"dui-m-form-item-text\"]{font-size:12px;height:30px;line-height:30px;font-weight:450}[data-duim-0-49-1~=\"dui-m-form-item-text-error\"]{color:#ff7272}");
var Form = { Item: Item_1.default };
exports.Form = Form;
exports.default = Form;
